/* Beweis-Video: stumm in Schleife, Antippen pausiert. Bewusst ohne native
   Controls, sonst kommt die Vollbild-Taste mit. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.smeluEggInit === '1') return;
    root.dataset.smeluEggInit = '1';
    var media = root.querySelector('.smelu-egg__media');
    var video = root.querySelector('[data-smelu-egg-video]');
    var tap = root.querySelector('[data-smelu-egg-tap]');
    if (!media || !video || !tap) return;

    function sync() {
      media.classList.toggle('is-paused', video.paused);
      tap.setAttribute('aria-label', video.paused ? 'Video abspielen' : 'Video pausieren');
    }
    tap.addEventListener('click', function () {
      if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      else { video.pause(); }
      sync();
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
          else if (!video.paused) { video.pause(); media.classList.remove('is-paused'); }
        });
      }, { threshold: 0.25 });
      io.observe(media);
    }
    sync();
  }
  function boot() { document.querySelectorAll('[data-smelu-egg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
